export default __webpack_public_path__ + "static/media/email.3d8f9677.svg";